import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faAngleUp,
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
  faTimes,
  faGlobe,
  faCheck,
  
  faFileAlt,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFileArchive
} from '@fortawesome/pro-light-svg-icons'

import  {
  faFacebook,
  faInstagram
} from '@fortawesome/free-brands-svg-icons'

// Build icon library
library.add(
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faAngleUp,
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
  faTimes,
  faGlobe,
  faCheck,
  
  faFileAlt,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFileArchive,

  faFacebook,
  faInstagram
)

// Register fa-icon component globally
Vue.component('fa-icon', FontAwesomeIcon)


// WEBPACK FOOTER //
// ../default-js/js/global/icons.js